import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

const WhoisModalContent = ( { whoisData } ) => {
    return (
        <>
            {whoisData.split( '\n' ).map( ( item, key ) => {
                return (
                    <Typography
                        variant="body2"
                        key={key}
                    >
                        {item}<br/>
                    </Typography>
                );
            } )}
        </>
    );
};

WhoisModalContent.propTypes = {
    whoisData: PropTypes.string
};

export default WhoisModalContent;
